import { render, staticRenderFns } from "./survey-step-diet-lifestyle-recommendation.vue?vue&type=template&id=60df487c"
import script from "./survey-step-diet-lifestyle-recommendation.vue?vue&type=script&lang=js"
export * from "./survey-step-diet-lifestyle-recommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports